import ApiService from "services/ApiService"

export const getUserSubcription = async () => {
    return await ApiService.get('/subscription')
}

export const createSubscriptionRequest = async (data) => {
    return await ApiService.post('/subscription/subscription-request', data)
}
